// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"f4152f24","110":"fc84d9d5","453":"37027f36","471":"67a096ce"}[chunkId] + ".chunk.js";
};